import { connect } from 'react-redux';
import InOutOrderTrans from '../component/statistic/InOutOrderTrans';
import InOutTrans from '../component/statistic/InOutTrans';
import InOutTransExternal from '../component/statistic/InOutTransExternal';
import WalletBalance from '../component/statistic/WalletBalance';
import action from '../redux/actions/statistic';

const mapStateToProps = (state) => ({
  markets: state.setting.coinSettings,
  coins: state.setting.coins,

  inOutOrderTrans: state.statistic.inOutOrderTrans,
  inOutTrans: state.statistic.inOutTrans,
  inOutTransExternal: state.statistic.inOutTransExternal,
  walletBalance: state.statistic.walletBalance,
  statisticDate: state.statistic.statisticDate,

  inOutOrderTransChart: state.statistic.inOutOrderTransChart,
  inOutTransChart: state.statistic.inOutTransChart,
  inOutTransExternalChart: state.statistic.inOutTransExternalChart,

});

const mapDispatchToProps = (dispatch) => ({
  onFetchInOutOrderTransAction: (params) => {
    dispatch(action.fetchInOutOrderTransAction(params));
  },
  onFetchInOutTransAction: (params) => {
    dispatch(action.fetchInOutTransAction(params));
  },
  onFetchInOutTransExternalAction: (params) => {
    dispatch(action.fetchInOutTransExternalAction(params));
  },
  onFetchWalletBalanceAction: (params) => {
    dispatch(action.fetchWalletBalanceAction(params));
  },
  onFetchInOutOrderTransChartAction: (params) => {
    dispatch(action.fetchInOutOrderTransChartAction(params));
  },
  onFetchInOutTransChartAction: (params) => {
    dispatch(action.fetchInOutTransChartAction(params));
  },
  onFetchInOutTransExternalChartAction: (params) => {
    dispatch(action.fetchInOutTransExternalChartAction(params));
  },
});

export const InOutOrderTransContainer = connect(mapStateToProps, mapDispatchToProps)(InOutOrderTrans);
export const InOutTransContainer = connect(mapStateToProps, mapDispatchToProps)(InOutTrans);
export const InOutTransExternalContainer = connect(mapStateToProps, mapDispatchToProps)(InOutTransExternal);
export const WalletBalanceContainer = connect(mapStateToProps, mapDispatchToProps)(WalletBalance);
